import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import ScatterPlotHeaderComponent from './Component';

export const withHeader = Children => observer(
  props => {
    const [showRegressionLine, setShowRegressionLine] = useState(false);
    const [showConfidenceIntervals, setShowConfidenceIntervals] = useState(false);

    const handleRegressionLineCheckboxChange = ({ target }) =>
      setShowRegressionLine(target.checked);

    const handleConfidenceIntervalsCheckboxChange = ({ target }) => {
      linearModel.setVisibleSlider(target.checked);
      setShowConfidenceIntervals(target.checked);
    };

    return (
      <div>
        <ScatterPlotHeaderComponent
          showRegressionLine={showRegressionLine}
          showConfidenceIntervals={showConfidenceIntervals}

          onRegressionLineCheckboxChange={handleRegressionLineCheckboxChange}
          onConfidenceIntervalsCheckboxChange={handleConfidenceIntervalsCheckboxChange}

          {...props}
        />

        <Children
          showRegressionLine={showRegressionLine}
          showConfidenceIntervals={showConfidenceIntervals}
          {...props}
        />
      </div>
    );
  }
);
